import { useMemo } from 'react';

export const useNavConfig = () => {
  return useMemo(() => [], []);
};
